import { CreatorInfo } from './get-element-preview'

export const getMetaTitleName = (creatorInfo: CreatorInfo) => {
  if (creatorInfo?.brandName) {
    return creatorInfo.brandName
  }

  if (creatorInfo?.firstname || creatorInfo?.lastname) {
    return `${creatorInfo.firstname} ${creatorInfo.lastname}`.trim()
  }

  return 'Taylora'
}
